import React from 'react';

export const OverviewTab = () => {
  return (
    <div data-testid="overview-tab">
      <div>Overview Tab - Coming Soon</div>
    </div>
  );
};
